/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".process-modal-content ui-process-io-parameters section{margin-bottom:40px}.process-modal-content ui-process-io-parameters section.no-parameters{margin-bottom:25px}"];
export { styles as styles };
